<template>
  <div class="events-list">
    <!-- <div class="event-list-title">
      <h2 v-if="events.length">
        Event<span v-if="events.length > 1">s</span> <span v-if="dateStr !== 'Today' && dateStr !== 'Tomorrow'"> on</span> <span> {{dateStr}}</span>
      </h2>
      <h2 v-else>
        No event <span v-if="dateStr !== 'Today' && dateStr !== 'Tomorrow'"> on</span> <span> {{dateStr}}</span>
      </h2>
    </div> -->
    <div class="events-list-container">
      <div class="cards-container" :style="{width: cardWidth * events.length + 'px'}">
        <currentcard v-for="(card,count) in events" :key="count" :attributes="card" />
      </div>
    </div>
    <!-- <div v-if="events.length > 1" class="gradient"></div> -->
  </div>
</template>

<script>
import currentcard from './currentcard.vue'
import projectMixin from '../projectmixin.js'
import {mapState} from 'vuex'
import _debounce from 'lodash/debounce'

export default {
  props: ['attributes'],
  mixins: [projectMixin],
  components: {
    currentcard
  },
  computed: {
    ...mapState(['eventsdata', 'eventsondate'])
  },
  data () {
    return {
      events: [],
      cardWidth: 280 + 10, // 10 padding
      dateStr: 'Today'
    }
  },
  watch: {
    eventsdata: function (newVal, oldVal) {
      this.getEventsBy({date: new Date()})
    },
    eventsondate: function (newVal, oldVal) {
      this.events = newVal
      this.adjustContainer()

      const now = new Date()
      var selectedDate = new Date(newVal.date)
      if (now.toLocaleDateString() === selectedDate.toLocaleDateString()) {
        this.dateStr = 'Today'
      } else {
        const options = {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }
        this.dateStr = selectedDate.toLocaleString('en-us', options)
        selectedDate.setDate(selectedDate.getDate() - 1)
        if (now.toLocaleDateString() === selectedDate.toLocaleDateString()) {
          this.dateStr = 'Tomorrow'
        }
      }
    }
  },
  methods: {
    resizeCard () {
      if (document.documentElement.clientWidth >= 960) {
        this.cardWidth = 350 + 10 // 10 padding
      } else {
        this.cardWidth = 280 + 10 // 10 padding
      }
    },
    adjustContainer () {
      if (this.events.length < 3) {
        this.$el.closest('div.component-content').classList.remove('container')
        this.$el.closest('div.component-content').classList.add('inline')
      } else {
        this.$el.closest('div.component-content').classList.remove('inline')
        this.$el.closest('div.component-content').classList.add('container')
      }
    }
  },
  mounted () {
    const self = this
    window.addEventListener('resize', _debounce(function () {
      self.resizeCard()
    }, 100))
    self.resizeCard()
  }
}
</script>

<style lang="scss" scoped>
.events-list {
  position: relative;

  .event-list-title {
    padding-bottom: 10px;
  }
  .events-list-container {
    width: 100%;
    overflow: auto;
    /* background-color: $greydark; */
    padding-bottom: 10px;
    .cards-container {
      width: 400vw;
    }
  }
  .gradient {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 40px;
    height: 100%;
    background: linear-gradient(90deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0) 50%,$greylight);
  }
}
</style>
